<template>
    <div style="padding-top: 65px;overflow: scroll;" :class="{'hidden':isPC}">
        <el-row>
<!--            返回栏-->
            <el-col :span="24" style="height: 60px;background-color:#EAEAEA;width: 100vw;box-shadow: inset 0px 10px 10px #DDDDDD;z-index: 2">
                <div style="">
                    <i class="el-icon-d-arrow-left" style="font-size: 20px;line-height: 58px; text-align: left;padding-left:40px;" @click="this.$router.go(-1)">
                        <i style="font-size: 18px;font-style: normal;font-weight: bold;"> {{base[0]}}</i>
                    </i>

                </div>

            </el-col>
<!--            主体-->
            <el-col>
                <div style="text-align: center;margin-top: 50px;padding: 40px 0;border-bottom:1px dotted #ccc ">
                    <h3 style="padding: 5px 0">{{list.title}}</h3>
                    <span>Freigabezeit：{{list.addTime}}</span>
                </div>


            </el-col>
            <el-col :offset="4" :span="16">
                <span style="color: #409EFF">Lösung</span>
                <div>
                    <img :src="list.imgpath" alt="" >
                </div>
                <div v-html="list.content"></div>
            </el-col>


        </el-row>
        <foot/>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import Foot from "@/ZH-CN/components/Foot";
    export default {
        name: "EE",
        components: {Foot},
        metaInfo: {
            title: 'Erhalten Sie Antworten von den Mitarbeitern und früheren Gästen des Nanjing Hengchuang Magnetoelectronics Co., Ltd.', // set a title
            meta: [{
                // 设置meta信息
                name: 'Hochleistung Ferritkern" Hochleistung·Weicher Ferritkern·Mangan Zink Ferritkern·Großer Kern·Röntgenkern·Hochspannungstransformatorkern·Mikrowellenferrit',
                content: 'Hochleistungsmagnetkern, Nanjing Hengchuang Magnetoelektronics spezialisiert sich auf die Herstellung von verschiedenen hochwertigen großen magnetischen Kernen, ' +
                    'Hochleistungsferritkern, weichen Ferritkernen, Mangan Zink Ferritkern, großen magnetischen Kernen, Röntgenkernen, Hochspannungstransformatorkernen, Telefon: 18913981759'
            }]
        },
        data(){

            return{
                isPC:true,
                base:['zurück',"软件制图",'产品介绍'],
                btns:['产品尺寸','相关介绍'],
                sn:'',
                list:[],
                lists:[],
                describe:'',
                dynamic:0,
                show:true,
                tableData: [],
                name:"",
                gcheck:true,
                hcheck:true,
                icheck:true,
                canDraw:false,

            }
        },
        methods:{
            _isMobile() {
                let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
                return flag;
            },



        },
        beforeMount(){
            if (this._isMobile()) {
                this.isPC=false;

            } else {

                this.isPC=true;
            }

            this.id=this.$route.query.id
           // alert(this.id)
            request.get("/mate_management/getOneById/"+this.id).then(res =>{
                this.list=res.data[0]
            })

        },



    }
</script>

<style lang="less" scoped>
    .hidden{
        overflow: hidden !important;
    }
    .carousel{
        border:1px solid rgba(64,158,255,.1);
        padding: 5px
    }
    .jianjie{
        padding: 30px 0;
        margin-top: 30px;
        border-top:1px solid rgba(0,0,0,.1);
        border-bottom:1px solid rgba(0,0,0,.1);
        color: #707070;
        font-size: 0.9em;
    }
    .menuBtn{
        li{
            border-bottom: 3px solid white;
            float: left;
            .el-button{
                border: none;
                border-radius: 0;
            }

        }
        li:hover{
            box-sizing: border-box;
            border-bottom: 3px solid #1C86EE;

        }
    }
    .colorChange{
        background-color: #1C86EE;
        color: white;
    }
</style>